import React from 'react';
import Button from 'components/DesignSystem/Button';

import './index.scss';

/**
 * Botão só com o ícone de lápis. `aria-label` e `title` são opcionais: sem eles o botão sai
 * idêntico ao de antes (snapshots dos consumidores); com eles, ganha nome para o leitor de tela e
 * a dica ao passar o mouse.
 */
export default function EditButton({
  onClick,
  id,
  'aria-label': ariaLabel = undefined,
  title = undefined,
}: {
  onClick: () => void,
  id: string,
  'aria-label'?: string,
  title?: string,
}) {
  return (
    <Button
      id={id}
      small
      icon="edit"
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
    />
  );
}
